import { createSlice } from "@reduxjs/toolkit";
import {
  getAllLeaves,
  getLeaveBalance,
  getLeaveStatistics,
} from "../action/leaveAction";

const initialState = {
  allLeaves: [],
  leaveBalance: [],
  leaveStatistics: null,
};

export const leaveSlice = createSlice({
  name: "leave",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAllLeaves.fulfilled, (state, action) => {
        // Only replace list when payload is an array (avoid blank list on wrong/empty API shape)
        if (Array.isArray(action.payload)) {
          state.allLeaves = action.payload;
        }
      })
      .addCase(getLeaveBalance.fulfilled, (state, action) => {
        state.leaveBalance = action.payload || [];
      })
      .addCase(getLeaveStatistics.fulfilled, (state, action) => {
        state.leaveStatistics = action.payload;
      });
  },
});

export default leaveSlice.reducer;

